module.exports = __webpack_public_path__ + "img/michelin-logo-1900x450.34afbaaa.png";